module.exports = __webpack_public_path__ + "media/images/common/icon/icon-cart-b-916c840b9cd138c378afa496e1257049.svg";